import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface FlowErrorPanelProps {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  loading?: boolean;
}

/** Qadam ichidagi doimiy xato paneli (toast o'rniga) */
export function FlowErrorPanel({ message, onRetry, retryLabel, loading }: FlowErrorPanelProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-2xl border border-destructive/20 bg-destructive/10 p-5">
      <AlertTriangle size={22} className="text-destructive" />
      <p className="flex-1 text-base text-destructive">{message}</p>
      {onRetry && (
        <Button variant="outline" className="h-12 text-base" onClick={onRetry} disabled={loading}>
          <RefreshCw size={16} className="mr-2" /> {retryLabel ?? t('pos_flow_error.retry')}
        </Button>
      )}
    </div>
  );
}
